import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { FinancialServiceViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/financial-service-view/financial-service-view-wrapper.component';

@Component({
  selector: 'app-financial-service-view-desktop',
  templateUrl: './financial-service-view-desktop.component.html',
  styleUrls: ['./financial-service-view-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinancialServiceViewDesktopComponent extends FinancialServiceViewWrapperComponent {

}
